export function shortAddress(addr: string, start: number = 3, end: number = 3): string {
  if (!addr) return "";
  if (addr.length <= start + end) return addr;
  return `${addr.slice(0, start)}...${addr.slice(-end)}`;
}

export function timeAgo(isoOrDate: string | Date | undefined): string {
  if (!isoOrDate) return "-";
  const ts = typeof isoOrDate === "string" ? new Date(isoOrDate).getTime() : isoOrDate.getTime();
  if (isNaN(ts)) return "-";
  const diff = Date.now() - ts;
  if (diff < 0) return "just now";
  if (diff < 1000) return `${diff}ms`;
  if (diff < 60_000) return `${Math.floor(diff / 1000)}s`;
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h`;
  return `${Math.floor(diff / 86_400_000)}d`;
}